import { PDFDownloadLink } from "@react-pdf/renderer";
import React from "react";
import GlobalTable from "../../../components/global-table";
import { Button, InputField, Typography } from "../../../ppui";
import { getMonthInStringNotOneIndexBased } from "../../../utils/common";
// import { logger } from "../../../utils/logger";
import { ContentLayout, ContentTable } from "../../style";
import { SalaryHeaders } from "./epfreport.data";
import EpfPdf from "./pdf-report";
import useEPFReportService from "./use-epf-report-service";

function EpfReport() {
  const {
    EPFReportListData,
    epfReportInputs,
    handleChange,
    dataFetched,
    handleExportClick,
    loadingAllEPFReport,
    epfReportPDFData,
    epfReportSummary,
    rowsPerPage,
    currentPage,
    totalPages,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    searchQuery,
    setSearchQuery,
    organizationInfo,
  } = useEPFReportService();
  const orgInitials = organizationInfo?.org_name?.split(' ').map(word => word[0]?.toUpperCase()).join('');
  // logger.log(EPFReportListData, "EPFReportListDataPrity");
  return (
    <>
      <ContentLayout>
        <ContentTable>
          <GlobalTable
            headers={SalaryHeaders(currentPage, rowsPerPage)}
            rows={EPFReportListData}
            ActiveSort={false}
            searchBox={true}
            columnManagement={false}
            avatar={true}
            stickyHeader="true"
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            actionLeft={
              <>
                <Typography variant="h5" mb="0">
                  {/* {`${dataFetched ? epfReportSummary?.total_epf_member :'' } Employees EPF Report of ${getMonthInStringNotOneIndexBased(epfReportPDFData[0]?.month)} ${epfReportPDFData[0]?.year} `} */}
                  {/* {dataFetched && epfReportSummary?.total_epf_member}  */}
                  EPF Report{" "}
                  {(dataFetched && epfReportPDFData.length>0)&&
                    `of ${getMonthInStringNotOneIndexBased(epfReportPDFData[0]?.month)} ${epfReportPDFData[0]?.year}`}
                </Typography>
              </>
            }
            actionRight={
              <>
                <InputField
                  label="Report Month"
                  name="month"
                  type="month"
                  placeholder="Type Here..."
                  valueSinc
                  value={epfReportInputs?.report_month}
                  onChange={(e) => handleChange(e.target.value, "report_month")}
                  onKeyDown={(e) => e.preventDefault()}
                />
                {dataFetched ? (
                  <PDFDownloadLink
                    document={
                      <EpfPdf
                        epfReportPDFData={epfReportPDFData}
                        epfReportSummary={epfReportSummary}
                        organizationInfo={organizationInfo}
                      />
                    }
                    fileName={`${orgInitials}-epf-report.pdf`}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleExportClick}
                      loading={loadingAllEPFReport}
                      disabled={EPFReportListData.length > 0 ? false : true}
                    >
                      Export
                    </Button>
                  </PDFDownloadLink>
                ) : (
                  <Button color="primary" variant="contained" disabled={true}>
                    Export
                  </Button>
                )}
              </>
            }
          />
        </ContentTable>
      </ContentLayout>
    </>
  );
}

export default EpfReport;
